export default __webpack_public_path__ + "static/inventory-system-1-6f8b9bd64ce1294227e8ab3282fbf50d.png";